import React, {useState, useRef, useEffect} from 'react';
import Search from './Search';
import Button from "@hig/button";
import Profile from './Profile';
import './style.scss';
import {fetchJson} from "../../utils/util_functions";

export default function NavHeaderTop({ profile, isLoaded, isDarkTheme }) {

  const [numOfHubs, setNumOfHubs] = useState(0);

  useEffect(() => {
    // Check if user is logged in by checking profile data
    const isUserLoggedIn = profile && profile.message === undefined && profile.oxygen_id;
    if (isUserLoggedIn) {
      // Only fetch hubs if user is logged in
      fetchJson(process.env.HUBS_PATH)
        .then((json) => {
          //if error happens
          if(!json)
            setNumOfHubs(0);
          else
            setNumOfHubs(json.results.length);
        });
    } else {
      // User not logged in, keep hub count at 0
      setNumOfHubs(0);
    }
  }, [profile]);

  return (
    <div className={`aps__nav-header__top`}>
      <div className={`constrain`}>
        <div className={`aps__logo`} key={`logo`}>
          <a
            data-test-id="aps-logo-header-link"
            data-external-target="aps-logo-header-link"
            href="//aps.autodesk.com/"
            title="Autodesk Platform Services"
            aria-label="Autodesk Platform Services"
          >
            <img
              src="//aps.autodesk.com/static/1.0.0.20251110232813/images/aps-logo--white.svg"
              alt="Autodesk Platform Services"
            />
          </a>
        </div>
        <Search key={`search`}/>
        <div className='aps__nav-header__hub-button-wrapper'>
          <Button
            size="standard"
            title={"Developer hubs"}
            link={'/hubs/'}
            style={{
              backgroundColor: "#000",
              borderColor: "#fff",
              display: numOfHubs > 0 ? 'block' : 'none'
              // display: true ? 'block' : 'none'
            }}
          />
        </div>
        <Profile key={`profile`} profile={profile} isLoaded={isLoaded} isDarkTheme={isDarkTheme} />
      </div>
    </div>
  );
};
